 const HeadeMenu = [{
         label: '首页',
         path: '/home',
         name: 'home'
     },
     {
         label: 'CheatDefender',
         path: '/cheatdefender',
         name: 'cheatdefender'
     },
     {
         label: '关于我们',
         path: '/about',
         name: 'about'
     },
     {
         label: '联系我们',
         path: '/contact',
         name: 'contact'
     }
 ]

 export default HeadeMenu